import React from "react"
import Text from "../Text/text"
import Styles from "./input.less"

import editImg from "./image/编辑.svg"
import useCurrentRobotInput from "./share/useCurrentRobotInput"

export interface InputProps {
    data: InputData
    onEdit: () => void
    onMouseEnter: () => void
    onMouseLeave: () => void
    isFullScreen?: boolean
}

export interface InputData {
    type: "input" | "answer"
    content: string
}

const Input: React.FC<InputProps> = (props) => {
    const {data, onEdit, isFullScreen} = props
    const [input, setInput] = useCurrentRobotInput()

    const handleEdit = () => {
        setInput(data.content)
        onEdit && onEdit()
    }

    return (
        <section className={Styles["section"]}>
            <Text
                onMouseLeave={props.onMouseLeave}
                onMouseEnter={props.onMouseEnter}
                type={data.type}
                content={data.content}
                isFullScreen={isFullScreen}
                style={{paddingRight: 30}}
            />
            <img src={editImg} onClick={handleEdit} className={Styles["edit"]} />
        </section>
    )
}

export default Input
